export type TitleChangeHandler = (title: string) => void;

export class ContentTypeTitleService {
	private titleChangeHandler: TitleChangeHandler;

	constructor() {
		this.titleChangeHandler = () => {};
	}

	updateTitle(title: string): void {
		this.titleChangeHandler(title);
	}

	setTitleChangeHandler(cb: TitleChangeHandler): void {
		this.titleChangeHandler = cb;
	}
}

export const contentTypesTitleServiceSingleton: ContentTypeTitleService =
	new ContentTypeTitleService();
